import React from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles.scss';

const IframeDialog = function IframeDialog(props) {
    const {
        content, clickHandler, paperPropsStyle, isMobile, hideScroller,
    } = props;

    const dialogActions = (
        <DialogActions>
            <CloseIcon
                onClick={() => clickHandler(false)}
                style={{ cursor: 'pointer' }}
            />
        </DialogActions>
    );

    const contentStyle = {
        overflow: hideScroller ? 'hidden' : 'auto',
        textAlign: 'center',
    };

    const mobileContentStyle = {
        ...contentStyle, margin: 'auto', padding: '0px', width: '340px',
    };

    return (
        // PaperProps is a dialog props applied to the Paper element,
        // paperPropsStyle is to control the style of dialog
        // https://mui.com/api/dialog/
        <Dialog
            open
            PaperProps={{ style: paperPropsStyle }}
            className={styles.IframeDialog}
        >
            {dialogActions}
            <DialogContent style={isMobile ? mobileContentStyle : contentStyle}>
                {content}
            </DialogContent>

        </Dialog>
    );
};

IframeDialog.propTypes = {
    content: PropTypes.element.isRequired,
    clickHandler: PropTypes.func.isRequired,
    paperPropsStyle: stylePropType.isRequired,
    hideScroller: PropTypes.bool,
    isMobile: PropTypes.bool,
};

IframeDialog.defaultProps = {
    hideScroller: false,
    isMobile: false,
};

export default IframeDialog;
